import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../config";
import { TOKEN_KEY } from "../constants/storageKey";

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

export default function AxiosProvider({ children }) {
  const navigate = useNavigate();
  axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  useEffect(() => {
    axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem(TOKEN_KEY);
          navigate("/login", {
            state: { feedbackMessage: "Session expirée" },
          });
        }
        return Promise.reject(error);
      }
    );
  }, [navigate]);

  return children;
}
